import * as Yup from "yup";

export const depositSchema = Yup.object({
  amount: Yup.string().required("amount is required"),
  upi: Yup.string().required("UPI is required"),
  utr_number: Yup.string().required("UTR number is required"),
});
